/**
 * UTM Parameters, GCLID & Referrer Tracking for Gravity Forms
 *
 * 1. Captures UTM parameters and gclid from the URL on every page visit.
 *
 * 2. Captures document.referrer on first visit (when no referrer is stored yet).
 *
 * 3. Stores them in localStorage with a timestamp (expires after 30 days).
 *
 * 4. When any Gravity Forms form is rendered, populates UTM/gclid/referrer fields
 *    using the field-map provided by PHP (window.amsUtmFieldMap).
 */

(function () {
	'use strict';

	var UTM_PARAMS = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
		'utm_id',
		'utm_device',
		'utm_matchtype',
		'utm_network'
	];

	var STORAGE_KEY = 'ams_utm';
	var MAX_AGE_MS  = 30 * 86400000; // 30 days

	function saveUTM(data) {
		try {
			var record = { ts: Date.now(), values: data };
			localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
		} catch (e) { /* quota / private-browsing — silently ignore */ }
	}

	function loadUTM() {
		try {
			var raw = localStorage.getItem(STORAGE_KEY);
			if (!raw) return null;

			var record = JSON.parse(raw);

			if (Date.now() - record.ts > MAX_AGE_MS) {
				localStorage.removeItem(STORAGE_KEY);
				return null;
			}

			return record.values || null;
		} catch (e) {
			return null;
		}
	}

	function captureUTM() {
		var params  = new URLSearchParams(window.location.search);
		var hasUTM  = UTM_PARAMS.some(function (p) { return params.has(p); });
		var hasGclid = params.has('gclid');

		// Nothing new in the URL — only capture referrer if we have no record yet
		if (!hasUTM && !hasGclid) {
			captureReferrerOnly();
			return;
		}

		var data = {};
		UTM_PARAMS.forEach(function (p) {
			data[p] = params.get(p) || '';
		});

		// GCLID
		if (hasGclid) {
			data['gclid'] = params.get('gclid');
		}

		// Referrer — attach to the same record
		if (document.referrer) {
			data['referrer'] = document.referrer;
		}

		saveUTM(data);
	}

	/**
	 * When the URL has no UTM/gclid params we still want to
	 * store the referrer on the very first visit.
	 */
	function captureReferrerOnly() {
		var existing = loadUTM();

		// Already have a record — don't overwrite
		if (existing) return;

		if (document.referrer) {
			saveUTM({ referrer: document.referrer });
		}
	}

	function setFieldValue(input, value) {
		if (!input || !value) { return; }
		input.value = value;
		input.dispatchEvent(new Event('input',  { bubbles: true }));
		input.dispatchEvent(new Event('change', { bubbles: true }));
	}

	function populateFromFieldMap(formId, utmData) {
		var map = window.amsUtmFieldMap && window.amsUtmFieldMap[formId];
		if (!map) return false;

		var populated = false;

		// map = { "input_21_10": "utm_source", "input_21_11": "utm_medium", … }
		for (var inputId in map) {
			if (!map.hasOwnProperty(inputId)) continue;

			var param = map[inputId];
			var input = document.getElementById(inputId);

			if (input && utmData[param]) {
				setFieldValue(input, utmData[param]);
				populated = true;
			}
		}

		return populated;
	}

	function populateGFFields(formId) {
		var utmData = loadUTM();
		if (!utmData) return;

		populateFromFieldMap(formId, utmData);
	}

	captureUTM();

	if (typeof jQuery !== 'undefined') {
		jQuery(document).on('gform_post_render', function (event, formId) {
			populateGFFields(formId);
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		var wrappers = document.querySelectorAll('.gform_wrapper');
		wrappers.forEach(function (w) {
			var match = w.id && w.id.match(/gform_wrapper_(\d+)/);
			if (match) {
				populateGFFields(match[1]);
			}
		});
	});

})();
